<template>
  <span class="rf-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.25 7.07l9.75 6.7 9.75-6.7V5.25H2.25v1.82zm19.5 2.73L12 16.5 2.25 9.8v8.95h19.5V9.8zM0 18.75V3h24v18H0v-2.25z"
        fill="inherit"
        stroke="none"
      />
    </svg>
  </span>
</template>
